var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image flex-center",style:({'width': _vm.compWidth, 'height': _vm.compHeight})},[(_vm.video)?_c('video',{attrs:{"src":_vm.src,"loop":"","autoplay":""}}):_c('img',{attrs:{"src":_vm.src}}),(_vm.preview)?_c('a',{on:{"click":function($event){return _vm.$preview({src: _vm.src})}}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }